import React from 'react';
import { ListSelector } from './ListSelector';
import { SearchField } from './SearchField';
import { Spacer } from 'src/common';
import _ from 'lodash';
import { FilterOption } from '../types';

interface GenericListProps<T extends FilterOption = FilterOption> {
  filters: T[];
  handleOnSelect: (label: string) => void;
  handleOnSelectAll?: (isAdd: boolean) => void;
  searchString: string;
  setSearchString: (value: string) => void;
  emptyTextWithSearch: string;
  checkIsYou?: (option: T) => boolean;
  prioritySortString?: string;
  showSearchField?: boolean;
}

const emptyFields = [
  'No Strategy',
  'No Owner',
  'No Framework',
  'No Status',
  'No Existing Maturity',
  'No Target Maturity',
  'No Assessment',
];

export const GenericList = <T extends FilterOption = FilterOption>({
  filters,
  handleOnSelect,
  handleOnSelectAll,
  searchString,
  setSearchString,
  emptyTextWithSearch,
  checkIsYou,
  prioritySortString = 'no owner',
  showSearchField = true,
}: GenericListProps<T>) => {
  const filtered = _.chain(filters)
    .filter((el) => el.label.toLowerCase().includes(searchString.toLowerCase()))
    .map((el) => {
      const cleanLabel = el.label.replace(/\([^)]+@[^\s)]+\)/, '').trim();
      let displayLabel = cleanLabel;

      if (el.label === 'No Assessment') {
        displayLabel = '[Not linked to an assessment]';
      } else if (emptyFields.includes(el.label)) {
        displayLabel = '[Blank]';
      }

      return {
        ...el,
        originalLabel: el.label,
        label: displayLabel,
      };
    })
    .orderBy(
      [(el) => (el.label.toLowerCase() === prioritySortString ? 0 : 1), (el) => el.label.toLowerCase()],
      ['asc', 'asc'],
    )
    .value();

  return (
    <>
      {showSearchField && (
        <>
          <SearchField onChange={(e) => setSearchString(e.target.value)} value={searchString} />
          <Spacer $px={16} />
        </>
      )}
      <ListSelector<T>
        data={filtered}
        selected={filtered.filter((el) => el.enabled).map((el) => el.label)}
        onSelectAll={handleOnSelectAll}
        onSelect={(displayLabel) => {
          const item = filtered.find((el) => el.label === displayLabel);
          if (item && item.originalLabel) {
            handleOnSelect(item.originalLabel);
          }
        }}
        emptyText={searchString ? 'No results found' : emptyTextWithSearch}
        checkIsYou={checkIsYou}
        allSelectorDisabled={!!searchString}
      />
    </>
  );
};
